













































import { Component, Vue } from 'vue-property-decorator';
import { api } from '@/api';
import { appName } from '@/env';

@Component
export default class ResetPassword extends Vue {
  public appName = appName;
  public password = '';

  // Lifecycle Functions
  public async created() {
  }
  public async submit() {
    const token: string = this.$route.query.token as string;
    if (token != null) {
      const response = await api.resetPassword(this.password, token);
      if (response) {
        if (response.status === true) {
          this.$router.push('/login');
        }
      }
    }
  }
}
